
import Feedbacks from '../../components/feedbacks/Feedbacks'
export const FeedbackContainer = () => {
  return (
    <Feedbacks />
  );
};

export default FeedbackContainer;
